import ReactPDF from '@react-pdf/renderer';
import React from 'react';
import { VisaDocumentProps } from './types';
import { VisaDocumentFR } from './visaDocument/VisaDocumentFR';
import { VisaDocumentENGBExhibitor } from './visaDocument/VisaDocumentENGBExhibitor';
import LanguageHelper from '../common/helpers/language/LanguageHelper';
import { VisaDocumentENGBVisitor } from './visaDocument/VisaDocumentENGBVisitor';
import { VisaDocumentAU } from './visaDocument/VisaDocumentAU';
import { VisaDocumentType } from './Visa.enums';
import { VisaDocumentMXExhibitor } from "./visaDocument/VisaDocumentMXExhibitor";

export class Visa {
  private static async getEnglishExhibitorVisaDocumentAsBlob(props: VisaDocumentProps) {
    return ReactPDF.pdf(
      <VisaDocumentENGBExhibitor {...props} />
    ).toBlob();
  }

  private static async getMexicoExhibitorVisaDocumentAsBlob(props: VisaDocumentProps) {
    return ReactPDF.pdf(
      <VisaDocumentMXExhibitor {...props} />
    ).toBlob();
  }

  private static async getEnglishVisitorVisaDocumentAsBlob(props: VisaDocumentProps) {
    return ReactPDF.pdf(
      <VisaDocumentENGBVisitor {...props} />
    ).toBlob();
  }

  private static async getAustralianVisaDocumentAsBlob(props: VisaDocumentProps) {
    return ReactPDF.pdf(
      <VisaDocumentAU {...props} />
    ).toBlob();
  }

  private static async getFrenchVisaDocumentAsBlob(props: VisaDocumentProps) {
    return ReactPDF.pdf(
      <VisaDocumentFR {...props} />
    ).toBlob();
  }

  static async get(props: VisaDocumentProps, eventLocale: string, type: VisaDocumentType) {
    LanguageHelper.locale = eventLocale;
    if (type === VisaDocumentType.FR) {
      return await this.getFrenchVisaDocumentAsBlob(props);
    }
    if (type === VisaDocumentType.ENGB_EXHIBITOR) {
      return await this.getEnglishExhibitorVisaDocumentAsBlob(props);
    }
    if (type === VisaDocumentType.MX_EXHIBITOR) {
      return await this.getMexicoExhibitorVisaDocumentAsBlob(props);
    }
    if (type === VisaDocumentType.ENGB_VISITOR) {
      return await this.getEnglishVisitorVisaDocumentAsBlob(props);
    }
    if (type === VisaDocumentType.AU) {
      return await this.getAustralianVisaDocumentAsBlob(props);
    }
  }
}
